import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import RedirectRoute from '../LegacyRedirect/RedirectRoute';

import LoginForm from '../LoginForm/LoginForm';
import Impersonate from '../Impersonate/Impersonate';
import SigningThankYouPage from '../SigningThankYouPage/SigningThankYouPage';
import MethodOfPaymentAuthorization from '../PaymentApplication/MethodOfPaymentAuthorization';
import PaymentMethodSuccessMessage from '../PaymentApplication/PaymentMethodSuccessMessage';

const GuarantorSignatureSuccess = lazy(() => import('../GuarantorSignature/GuarantorSignatureSuccess'));
const ChangePasswordForm = lazy(() => import('../ChangePassword/ChangePasswordForm'));
const RegisterUser = lazy(() => import('../RegisterUser/RegisterUser'));
const ResetPassword = lazy(() => import('../ResetPassword/ResetPassword'));
const ForgotPassword = lazy(() => import('../ForgotPassword/ForgotPassword'));
const AppSubmit = lazy(() => import('../AppSubmit/AppSubmit'));
const PaymentApplication = lazy(() => import('../PaymentApplication/PaymentApplication'));
const GuarantorSignature = lazy(() => import('../GuarantorSignature/GuarantorSignature'));
const About = lazy(() => import('../About/About'));

export default function PublicRoutes({ isPasswordExpired }) {
    return (
        <Suspense fallback={<span>...</span>}>
            <Switch>
                <Route exact path="/" component={LoginForm} />
                <Route exact path="/submit-application" render={(p) => <AppSubmit {...p} />} />                <Route exact path="/payment-application" render={(p) => <PaymentApplication {...p} />} />
                <Route exact path="/payment-method-success" render={(p) => <PaymentMethodSuccessMessage {...p} />} />
                <Route exact path="/guarantor-signature" render={(p) => <GuarantorSignature {...p} />} />
                <Route path="/guarantor-signature-success" render={(p) => <GuarantorSignatureSuccess {...p} />} />
                <Route path="/signing-success" render={(p) => <SigningThankYouPage {...p} />} />
                <Route path="/impersonate/:token" component={Impersonate} />
                <Route exact path="/about" render={(p) => <About {...p} />} />
                <Route path="/resetpassword" render={(p) => <ResetPassword {...p} />} />
                <Route path="/login" component={LoginForm} />
                <Route path="/register" render={(props) => <RegisterUser {...props} />} />
                <Route path="/forgotpassword" render={(props) => <ForgotPassword {...props} />} />
                <Route path="/method-of-payment-authorization" render={(p) => <MethodOfPaymentAuthorization {...p} />} />
                <RedirectRoute path="/User/OnlineRegistration.aspx" notRelatedToAccount />
                <RedirectRoute path="/Login.aspx" notRelatedToAccount />
                <RedirectRoute path="/User/ForgotPassword.aspx" notRelatedToAccount />
                <Route
                    render={(props) =>
                        isPasswordExpired ? <ChangePasswordForm {...props} /> : <LoginForm {...props} />
                    }
                />
            </Switch>
        </Suspense>
    );
}
